
import eventBus from '../../../../plugins/eventBus'
import { addToCartSuccess } from '@/plugins/popups'
import { Component, Vue } from 'vue-property-decorator'
import { ItemModel } from '@/store/models/ItemModel'
import { FavoritesStore } from '@/store/stores/FavoritesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component
export default class Favorites extends Vue {
  search: string = ''
  message: string = ''
  favorites: FavoritesStore = FavoritesStore.getInstance()
  envConfigurations: object = envConfiguration

  calcText(text: string, slice: number) {
    if (!text) return 'Nuk Ka Emër'
    if (text.split(/(\s*[.,]?\s*)+/).length > 65) {
      return `${text.substring(0, slice)}...`
    }
    return text
  }

  addToCart(product: ItemModel) {
    if (product.outOfStock) {
      return
    }
    eventBus.$emit('cart:item-added', product)
    addToCartSuccess()
  }

  filterFavorites() {
    let sortedArray: ItemModel[] = this.favorites.getStore()
    const filtered: any = this.favorites.getStore().filter((favorite) => {
      return favorite.name.toLowerCase().includes(this.search.toLowerCase())
    })

    this.favorites.sort('outOfStock')

    if (this.search) {
      sortedArray = filtered
      if (sortedArray.length === 0) {
        this.message = 'Nuk ka rezultate! 🤷‍♂️'
      }
      return sortedArray
    }

    if (sortedArray.length === 0) {
      this.message = 'Ju nuk keni produkte të preferuara 🤷‍♂️'
    }
    return sortedArray
  }

  mounted() {
    this.favorites.loadData()
    eventBus.$on('item:deleted-favorite', () => this.favorites.loadData())
  }

  beforeDestroy() {
    eventBus.$off('item:deleted-favorite', () => this.favorites.loadData())
  }
}
